export default __webpack_public_path__ + "static/media/img (2).4c3f0203.jpg";